import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { useFirestoreConnect } from 'react-redux-firebase';
import _ from 'lodash';
import ReactBSAlert from "react-bootstrap-sweetalert";
import moment from 'moment';
import { useTranslation } from "react-i18next";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Form,
  Input,
  FormText,
  Progress,
  Row,
  Col,
  Button,
  UncontrolledTooltip
} from "reactstrap";

import Select from "react-select";

import { newGroupSchema } from '../../variables/schema';
import readXlsxFile from 'read-excel-file'
import { useFirebase, useFirestore } from 'react-redux-firebase';
import { asyncForEach } from 'helpers/async';
import { koreanAge } from 'helpers/datetime';

function CurriculumResultForm(props) {
  const { channel, contents, allContents } = props;

  const [subgroup, setSubgroup] = useState(props.subgroup || null);
  const [group, setGroup] = useState(props.group || null);
  const [member, setMember] = useState(props.member || null);
  const [curriculumResult, setCurriculumResult] = useState(props.currentItem ? _.cloneDeep(props.currentItem) : null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [onSaving, setOnSaving] = useState(false);
  const [isModified, setIsModified] = useState(false);

  const [alert, setAlert] = useState(null);

  const firebase = useFirebase();
  const firestore = useFirestore();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (props.currentItem?.id) {
      const _curriculumResult = _.clone(props.currentItem);
      delete _curriculumResult.id;
      setCurriculumResult(_curriculumResult);
    } else {
      setCurriculumResult({
        groupId: group.id,
        groupTitle: group.title,
        subgroupId: subgroup.id,
        subgroupTitle: subgroup.title,
        memberId: member.id,
        memberName: member.name,
      })
    }
    return () => {
      //clean up
    }
  }, [props.currentItem])

  useEffect(() => {
    const currentCR = _.cloneDeep(props.currentItem);
    if (currentCR == null && (curriculumResult == null || Object.keys(curriculumResult).length == 6)) {
      return
    }
    if (currentCR?.id) {
      delete currentCR.id;
    }
    const modified = !_.isEqual(currentCR, curriculumResult);
    console.log("modified: ", modified);
    setIsModified(modified);
    return () => {
      // cleanup
    };
  }, [curriculumResult]);

  const onSave = async () => {
    console.log('press save');

    setOnSaving(true);

    const timestamp = {
      updatedAt: firestore.FieldValue.serverTimestamp()
    }

    if (!props.currentItem?.id) {
      timestamp['createdAt'] = firestore.FieldValue.serverTimestamp();
    }

    try {
      let curriculumResultRef = firestore.collection(`channels/${channel.id}/groups/${props.group.id}/members/${member.id}/curriculumResults`);
      if (props.currentItem?.id) {
        curriculumResultRef = curriculumResultRef.doc(props.currentItem?.id);
      } else {
        curriculumResultRef = curriculumResultRef.doc();
      }
      await curriculumResultRef.set({
        ...curriculumResult,
        ...timestamp,
      });
      props.afterSave && props.afterSave();
    } catch (error) {
      console.error('Failed to save : ', error);
    } finally {
      setOnSaving(false);
      props.toggle();
    }
  }

  const onDelete = async () => {
    const curriculumResultRef = firestore.collection(`channels/${channel.id}/groups/${props.group.id}/members/${props.member.id}/curriculumResults`).doc(props.currentItem.id);
    await curriculumResultRef.delete();
    props.toggle();
    props.afterDelete && props.afterDelete();
  }

  const onCancel = () => {
    setCurriculumResult(null);
    if (isModified) {
      props.closeConfirm();
    } else {
      props.toggle();
    }
  }

  const warningWithConfirmAndCancelMessage = () => setAlert(
    <ReactBSAlert
      warning
      style={{ display: "block", marginTop: "-100px" }}
      title={<div>{t('삭제하면 복구할 수 없습니다.')}<br />{t('계속 진행하시겠습니까?')}</div>}
      onConfirm={() => {
        onDelete();
        setAlert(null);
      }}
      onCancel={() => setAlert(null)}
      confirmBtnBsStyle="info"
      cancelBtnBsStyle="danger"
      confirmBtnText={t("확인")}
      cancelBtnText={t("취소")}
      showCancel
    >
      {t('지우면 완전히 삭제됩니다. 지우시겠습니까?')}
        </ReactBSAlert>
  )

  const onChange = (e, name, typeFn) => {
    const value = e.target.value;
    console.log('value: ', value);
    setCurriculumResult({ ...curriculumResult, [name]: typeFn ? typeFn(value) : value });
  }

  return (
    <div className='content'>
      {alert}
      {/* name */}
      <Row>
        <Col>
          <h5 className='text-info'>{t("차시정보")}</h5>
        </Col>
        <Col>
          <div className="text-right"><span className="ml-1" style={{ color: 'red', fontSize: 20 }}>*</span>{t("필수 입력 사항입니다")}</div>
        </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t("이름")}</label></Col>
          </Row>
          <FormGroup>
            <Input
              readOnly
              value={member?.name || ''}
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t("생년월일")}</label></Col>
          </Row>
          <FormGroup>
            <Input
              type={'date'}
              readOnly
              value={member?.birthday || ''}
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t("나이")}</label></Col>
          </Row>
          <FormGroup>
            <Input
              type={'number'}
              readOnly
              value={member?.age || ''}
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t("성별")}</label></Col>
          </Row>
          <FormGroup>
            <Input
              type={'select'}
              readOnly
              value={member?.gender || ''}
            >
              <option></option>
              <option>{t("남")}</option>
              <option>{t("여")}</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t('총판')}</label></Col>
          </Row>
          <FormGroup>
            <Input
              readOnly
              value={channel?.title || ''}
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t("가맹점")}</label></Col>
          </Row>
          <FormGroup>
            <Input
              readOnly
              value={group?.title || ''}
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t("클래스")}</label></Col>
          </Row>
          <FormGroup>
            <Input
              readOnly
              value={subgroup?.title || ''}
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t("차시")}</label></Col>
          </Row>
          <FormGroup>
            <Input
              readOnly
              value={curriculumResult?.lessonNo || ''}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t("콘텐츠")}</label><span className="ml-1" style={{ color: 'red', fontSize: 20 }}>*</span></Col>
          </Row>
          <FormGroup>
            <Select
              className="react-select primary"
              classNamePrefix="react-select"
              name="content"
              value={{
                value: curriculumResult?.contentId || '',
                label: (curriculumResult?.contentId && contents) ? contents[curriculumResult.contentId].title : '',
              }}
              onChange={({ value, label }) => {
                console.log('value = ', value);
                console.log('label = ', label);

                if (value !== curriculumResult?.contentId) {
                  setCurriculumResult({ ...curriculumResult, contentId: value });
                }
              }}
              options={[
                {
                  value: "",
                  label: "콘텐츠 선택",
                  isDisabled: true
                },
                ...allContents?.map((item, idx) => ({ value: item.contentId, label: item.title }))
              ]}
              placeholder={t("콘텐츠 설정")}
            />
          </FormGroup>
        </Col>
        <Col xs={6}>
          <Row className="align-items-center justify-content-between">
            <Col><label>{t("결과")}</label><span className="ml-1" style={{ color: 'red', fontSize: 20 }}>*</span></Col>
          </Row>
          <FormGroup>
            <Input
              value={curriculumResult?.result}
              type='number'
              onChange={e => onChange(e, 'result', (t) => Number(t))} />
          </FormGroup>
        </Col>
      </Row>
      {
        errorMessage
          ? <div>
            <p className="text-danger">{errorMessage}</p>
          </div>

          : null
      }

      <Row>
        {/* {
          props.currentItem?.id
            ? <Col>
              <Button color="danger" onClick={warningWithConfirmAndCancelMessage}>삭제</Button>
            </Col>
            : null
        } */}
        <Col className='text-right'>
          <Button color="primary" disabled={onSaving || !Boolean(curriculumResult?.contentId && curriculumResult?.result) || !isModified} onClick={onSave}>{t("저장")}</Button>
          <Button color="warning" onClick={onCancel}>{t("취소")}</Button>
        </Col>
      </Row>


    </div>
  )
}


CurriculumResultForm.propTypes = {
  subgroup: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  member: PropTypes.object.isRequired,
  afterSave: PropTypes.func,
  afterDelete: PropTypes.func,
  onCancel: PropTypes.func,
};

export default CurriculumResultForm

